import Vue from "vue";
import Router from "vue-router";
import { goPAGE } from "./utils/utils";

Vue.use(Router);

const classify = goPAGE();
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};

export default new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      redirect: `/${classify}/Index`,
    },
    {
      path: "/pc",
      name: "home",
      component: () => import("./views/pc/Home"),
      children: [
        {
          path: "/pc/Index",
          name: "Index",
          component: () => import("./views/pc/Index"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/BlockList",
          name: "BlockList",
          component: () => import("./views/pc/BlockList/BlocksList.vue"),
          meta: {
            alive: true,
          },
        },

        {
          path: "/pc/BkHash",
          name: "BkHash",
          component: () => import("./views/pc/BkHash/BkHash.vue"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/To",
          name: "To",
          component: () => import("./views/pc/BkHash/To.vue"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/BkHeight",
          name: "BkHeight",
          component: () => import("./views/pc/BkHash/BkHeight.vue"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/BkDetail",
          name: "BkDetail",
          component: () => import("./views/pc/BkHash/BkDetail.vue"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/TopValidators",
          name: "TopValidators",
          component: () => import("./views/pc/TopValidators/TopValidators.vue"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/ValidatorDetail",
          name: "ValidatorDetail",
          component: () =>
            import("./views/pc/TopValidators/TopValidatorsList.vue"),
            meta: {
              alive: true,
            },
        },
        {
          path: "/pc/TransactionsList",
          name: "TransactionsList",
          component: () =>
            import("./views/pc/TopValidators/TransactionsList.vue"),
            meta: {
              alive: true,
            },
        },
        {
          path: "/pc/TokensList",
          name: "TokensList",
          component: () => import("./views/pc/TopValidators/TokensList.vue"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/Tokens",
          name: "Tokens",
          component: () => import("./views/pc/Tokens/Tokens.vue"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/Overview",
          name: "Overview",
          component: () => import("./views/pc/Tokens/Overview.vue"),
          meta: {
            alive: true,
          },
        },
        
        {
          path: "/pc/Topnfts",
          name: "Topnfts",
          component: () => import("./views/pc/Nfts/Topnfts.vue"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/Contracts",
          name: "Contracts",
          component: () => import("./views/pc/TopValidators/Contracts.vue"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/Contractsdetail",
          name: "Contractsdetail",
          component: () =>
            import("./views/pc/TopValidators/Contractsdetail.vue"),
            meta: {
              alive: true,
            },
        },
        {
          path: "/pc/Accounts",
          name: "Accounts",
          component: () => import("./views/pc/TopValidators/Accounts.vue"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/Nfts",
          name: "Nfts",
          component: () => import("./views/pc/Nfts/NFTs.vue"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/NFTsList",
          name: "NFTsList",
          component: () => import("./views/pc/Nfts/NFTsList.vue"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/NFTsdetail",
          name: "NFTsdetail",
          component: () => import("./views/pc/Nfts/NFTsdetail.vue"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/NFTslistdetail",
          name: "NFTslistdetail",
          component: () => import("./views/pc/Nfts/NFTslistdetail.vue"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/charts",
          name: "charts",
          component: () => import("./views/pc/charts/charts.vue"),
          meta: {
            alive: true,
          },
        },
        {
          path: '/pc/AverageGas',
          name: 'AverageGas',
          component: () => import('./views/pc/charts/Blockchan/AverageGas.vue'),
          meta: {
            alive: true,
          },
        },
        {
          path: '/pc/DailyGas',
          name: 'DailyGas',
          component: () => import('./views/pc/charts/Blockchan/DailyGas.vue'),
          meta: {
            alive: true,
          },
        },
        {
          path: '/pc/PeakTPS',
          name: 'PeakTPS',
          component: () => import('./views/pc/charts/Blockchan/PeakTPS.vue'),
          meta: {
            alive: true,
          },
        },
        {
          path: '/pc/Transactionsignature',
          name: 'Transactionsignature',
          component: () => import('./views/pc/charts/Blockchan/Transactionsignature.vue'),
          meta: {
            alive: true,
          },
        },
        {
          path: '/pc/UserTransactions',
          name: 'UserTransactions',
          component: () => import('./views/pc/charts/Blockchan/UserTransactions.vue'),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/TFSCdetail",
          name: "TFSCdetail",
          component: () => import("./views/pc/charts/TFSCdetail.vue"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/Verify",
          name: "Verify",
          component: () => import("./views/pc/Developers/Verify.vue"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/Deployment",
          name: "Deployment",
          component: () => import("./views/pc/Developers/Deployment.vue"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/paid",
          name: "paid",
          component: () => import("./views/pc/Developers/Dsucess.vue"),
          meta: {
            alive: false,
          },
        },
        {
          path: "/pc/sucess",
          name: "sucess",
          component: () => import("./views/pc/Developers/sucess"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/Ownership",
          name: "Ownership",
          component: () => import("./views/pc/Ownership/Ownership"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/Ownersuccess",
          name: "success",
          component: () => import("./views/pc/Ownership/success"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/Ownererror",
          name: "error",
          component: () => import("./views/pc/Ownership/error"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/activateAccount",
          name: "success",
          component: () => import("./views/pc/Login/success"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/Congratuerror",
          name: "error",
          component: () => import("./views/pc/Login/error"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/Information",
          name: "Information",
          component: () => import("./views/pc/Ownership/Information"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/instructions",
          name: "Information",
          component: () => import("./views/pc/Ownership/instructions"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/resetsuccess",
          name: "Information",
          component: () => import("./views/pc/Login/resetpassword"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/Apis",
          name: "Apis",
          component: () => import("./views/pc/Apis/Apis"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/404", //404
          name: "404",
          component: () => import("./views/pc/404/404.vue"),
          meta: {
            alive: true,
          },
        },

      ],
    },
    {
      path: "/m",
      name: "home",
      component: () => import("./views/m/Home"),
      redirect: '/m/Index',
      children: [
        {
          path: "/m/Index",
          name: "Index",
          component: () => import("./views/m/Index"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/NoSearch",
          name: "NoSearch",
          component: () => import("./views/m/NoSearch"),
          meta: {
            alive: true,
          },
        },

        {
          path: "/m/BlockList",
          name: "BlockList",
          component: () => import("./views/m/BlockList"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/TransferList",
          name: "TransferList",
          component: () => import("./views/m/TransferList"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/TokensList",
          name: "TokensList",
          component: () => import("./views/m/TokensList"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/Toketop",
          name: "Toketop",
          component: () => import("./views/m/Toketop"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/AccountsList",
          name: "AccountsList",
          component: () => import("./views/m/AccountsList"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/ContractsList",
          name: "ContractsList",
          component: () => import("./views/m/ContractsList"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/NftsList",
          name: "NftsList",
          component: () => import("./views/m/NftsList"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/Topnfts",
          name: "Topnfts",
          component: () => import("./views/m/Topnfts"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/BlockHeight",
          name: "BlockHeight",
          component: () => import("./views/m/BlockHeight"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/BlockDetails",
          name: "BlockDetails",
          component: () => import("./views/m/BlockDetails"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/TransferDetails",
          name: "TransferDetails",
          component: () => import("./views/m/TransferDetails"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/Address",
          name: "Address",
          component: () => import("./views/m/Address"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/Overaddress",
          name: "Overaddress",
          component: () => import("./views/m/Overaddress"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/NftOveraddress",
          name: "NftOveraddress",
          component: () => import("./views/m/NftOveraddress"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/NftOveraddetail",
          name: "NftOveraddetail",
          component: () => import("./views/m/NftOveraddetail"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/NftOveraddetaillist",
          name: "NftOveraddetaillist",
          component: () => import("./views/m/NftOveraddetaillist"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/NFTslistdetail",
          name: "NFTslistdetail",
          component: () => import("./views/m/NFTslistdetail"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/VerifierList",
          name: "VerifierList",
          component: () => import("./views/m/VerifierList"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/VerifierDetail",
          name: "VerifierDetail",
          component: () => import("./views/m/VerifierDetail"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/NoSearch",
          name: "NoSearch",
          component: () => import("./views/m/NoSearch"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/VerifiernodeList",
          name: "VerifiernodeList",
          component: () => import("./views/m/VerifiernodeList"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/charts", //404
          name: "charts",
          component: () => import("./views/m/charts.vue"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/chartsdetail", //404
          name: "chartsdetail",
          component: () => import("./views/m/chartsdetail.vue"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/chartlist", //404
          name: "chartlist",
          component: () => import("./views/m/chartlist.vue"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/Contractdetail", //404
          name: "Contractdetail",
          component: () => import("./views/m/Contractdetail.vue"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/Verify",
          name: "Verify",
          component: () => import("./views/m/Verify"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/Deployment",
          name: "Deployment",
          component: () => import("./views/m/Deployment"),
          meta: {
            alive: false,
          },
        },
        {
          path: "/m/sucess",
          name: "sucess",
          component: () => import("./views/m/sucess"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/Ownership",
          name: "Ownership",
          component: () => import("./views/m/Ownership/Ownership"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/Ownersuccess",
          name: "success",
          component: () => import("./views/m/Ownership/success"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/Ownererror",
          name: "error",
          component: () => import("./views/m/Ownership/error"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/Information",
          name: "Information",
          component: () => import("./views/m/Ownership/Information"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/resetsuccess",
          name: "resetsuccess",
          component: () => import("./views/m/Login/resetpassword"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/instructions",
          name: "Information",
          component: () => import("./views/m/Ownership/instructions"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/activateAccount",
          name: "success",
          component: () => import("./views/m/Login/success"),
          meta: {
            alive: true,
          },
        },
      ],
    },
  ],
});
